import { useAppDispatch, useAppSelector } from 'universal-scripts'
import { Outlet } from 'react-router'
import Nav from '@components/Nav/Nav'
import UserMenu from '@components/UserMenu/UserMenu'
import { toggleSidebar } from 'src/store/slices/ui'

import logo from '@static/vectors/logo-datalab.svg'
import symbol from '@static/vectors/icon-datalab.svg'
import './PageLayout.css'

export default function PageLayout() {
  const dispatch = useAppDispatch()
  const isSidebarOpen = useAppSelector((state) => state.ui.isSidebarOpen)

  const handleClick = () => {
    dispatch(toggleSidebar())
  }

  return (
    <div className="page page-layout">
      <div className="datalab-symbol" onClick={handleClick}>
        <img src={isSidebarOpen ? logo : symbol} alt="datalab icon" />
        <span
          className={`icon icon-${isSidebarOpen ? 'collapse' : 'expand'}`}
        />
      </div>
      <aside className={`${isSidebarOpen ? 'open-sidebar' : ''} page-sidebar`}>
        <Nav />
        <UserMenu />
      </aside>
      <main className="page-main">
        <Outlet />
      </main>
    </div>
  )
}
